// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"3507be1d","385":"22371180","441":"2f047d4e","453":"99dcf01f","715":"b543f9db"}[chunkId] + ".chunk.js";
};